import { render, staticRenderFns } from "./BillingCardStatusBox.vue?vue&type=template&id=2c8f31e0&scoped=true&lang=pug"
import script from "./BillingCardStatusBox.vue?vue&type=script&lang=js"
export * from "./BillingCardStatusBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f31e0",
  null
  
)

export default component.exports